<template>
    <div>
        <div style="text-align: center;">
            <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
            <br/>
            <button @click="submitData"
                    type="button"
                    class="btn btn-success">
                ตกลง
            </button>
            &nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn-secondary">
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "delete-confirm-modal",
        methods : {
            submitData(){
                this.$emit("submit",true);
            },
            cancelData(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>